import { UserIcon } from '@heroicons/react/24/outline';
import Button from 'common/components/Button/Button';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Status from 'common/components/Status/Status';
import Icon from 'components/Icon/Icon';
import Role from 'common/components/Role/Role';
import WarningIcon from 'components/Icon/icons/WarningIcon';

function StudentItem({ item: user, onDelete, onNavigate }: any) {
  const profile = user?.profiles?.[0];
  const {
    username = user.email,
    lastname = null,
    firstname = null,
    establishment = null,
    training = null,
    isValidStudent = null,
  } = profile || {};

  const detailsLink = !!profile ? `/students/${user.id}` : `/users/edit/${user.id}`;

  const { t } = useTranslation();

  return (
    <div className="white-box responsive-flex-lg px-4 py-4 mt-2 w-full relative cursor-pointer transition-all">
      <Link to={detailsLink} className="responsive-flex-lg flex-1">
        <div className="flex flex-col flex-1 justify-between lg:pl-4 lg:pr-4">
          <div className="flex h-full gap-3">
            <div className="grid w-full gap-1 pt-3 lg:py-0">
              <div className="flex flex-row w-full items-center gap-1 mb-1 text-xl flex-wrap">
                <span className="font-bold text-primary leading-4">{username}</span>
                {' -  '}
                <span className="leading-4">{firstname}</span>
                <span className="leading-4">{lastname}</span>
                <div className="flex flex-row flex-1 justify-end items-center gap-1 text-lg">
                  <UserIcon className="w-4 h-4 mr-1" />
                  {user?.email}
                </div>
              </div>

              {!!profile && (
                <div className="flex flex-row items-center gap-1">
                  <Icon name="EstablishmentIcon" className="w-4 h-4 mr-1" />
                  {establishment
                    ? `${establishment?.name} (${String(establishment?.department?.CP).padStart(
                        2,
                        '0'
                      )})`
                    : '-'}
                </div>
              )}
              {!!profile && (
                <div className="flex flex-row items-center gap-1">
                  <Icon name="Training" className="w-4 h-4 mr-1" />
                  {training || '-'}
                </div>
              )}
              {!profile && (
                <div className="flex flex-row items-center gap-1 text-amber-700 italic opacity-60">
                  <WarningIcon className="w-4 h-4 mr-1" />
                  <div>{t('titleLegends.noProfile')}</div>
                </div>
              )}
            </div>
          </div>
        </div>
      </Link>

      <div className="flex flex-col justify-between items-end text-xs lg:border-l pl-4 min-w-[24em] border-slate-150 gap-2">
        <div className={user?.role ? 'flex justify-end gap-2' : ''}>
          <Role userRole={user?.role?.name} />
          <Status status={user?.confirmed ? 'email-validated' : 'email-not-validated'} />
          <Status status={user?.blocked ? 'blocked' : 'active'} />
          <Status status={isValidStudent ? 'student-validated' : 'student-not-validated'} />
        </div>

        <div className="flex w-full items-center justify-end text-slate-500">
          <div>
            <div className="flex w-full gap-1">
              <Button
                type="error-line"
                icon="TrashIcon"
                compact
                onClick={() => onDelete(user.id)}
                confirmMessage={t('actions.confirmDelete')}
              />
              <Button
                title={t('actions.edit')}
                type="warning-line"
                icon="PencilSquareIcon"
                onClick={() => onNavigate(user.id)}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default StudentItem;
